export const _en = {
    addButton: {
        label: "Add a resource situation"
    },
    dialog: {
        add: {
            title: "Add a situation",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        }
    },
    container: {
        informationContainer: {
            firstLine: "When selecting multiple resources, the application displays the common situations among all selected resources.",
            secondLine: "The selected resources do not share common situations."
        },
        hiddenContainer: {
            firstLine: "At least one of the selected resources is an anonymous resource.",
            secondLine: "An anonymous resource does not have situations and is always considered present."
        }
    }
};


export const _fr = {
    addButton: {
        label: "Situation"
    },
    dialog: {
        add: {
            title: "Ajout d'une situation",
            buttons: {
                save: "Sauvegarder",
                cancel: "Annuler"
            }
        }
    },
    container: {
        informationContainer: {
            firstLine: "En sélection multiple, l'application affiche les situations communes à l'ensemble des ressources sélectionnées.",
            secondLine: "Les ressources sélectionnées ne partagent pas de situations en communs."
        },
        hiddenContainer: {
            firstLine: "Au moins une des ressources sélectionnées est une ressource anonyme.",
            secondLine: "Une ressource anonyme ne dispose pas de situations et est considérée toujours présente."
        }
    }
};